import { ICommunity, IExclusiveContent } from '@search/services';

export const DynamicRouteBuilder = {
  creatorBySlug: (creatorSlug: string) => `/creators/${creatorSlug}`,
  communityBySlug: (creatorSlug: string, communityId: string) =>
    `/creators/${creatorSlug}/communities/${communityId}`,
  postBySlug: (creatorSlug: string, communityId: string, postId: string) =>
    `/creators/${creatorSlug}/communities/${communityId}/posts/${postId}`,
  commentBySlug: (creatorSlug: string, communityId: string, postId: string, commentId: string) =>
    `/creators/${creatorSlug}/communities/${communityId}/posts/${postId}/comments/${commentId}`,
  replyBySlug: (
    creatorSlug: string,
    communityId: string,
    postId: string,
    commentId: string,
    replyId: string,
  ) =>
    `/creators/${creatorSlug}/communities/${communityId}/posts/${postId}/comments/${commentId}/replies/${replyId}`,
  challenges: (creatorSlug: string) => `/creators/${creatorSlug}/challenges`,
  contents: (creatorSlug: string) => `/creators/${creatorSlug}/contents`,
  contentBySlug: (creatorSlug: string, contentSlug: string) =>
    `/creators/${creatorSlug}/contents/${contentSlug}`,
  badges: (creatorSlug: string) => `/creators/${creatorSlug}/badges`,
  leaderboards: (creatorSlug: string) => `/creators/${creatorSlug}/leaderboards`,
  about: (creatorSlug: string) => `/creators/${creatorSlug}/about`,
  fanBySlug: (creatorSlug: string, fanId: string) => `/creators/${creatorSlug}/fans/${fanId}`,
  topicBySlug: (creatorSlug: string, topicSlug: string) =>
    `/creators/${creatorSlug}/topics/${topicSlug}`,
};

type RouteBuilder = (item: any, isCreator: boolean) => string;

export const searchRoutes: Record<string, RouteBuilder> = {
  community: (item: ICommunity, isCreator) => {
    const slug = item.slug ?? item.id;
    const mainPostRef = item.parent_post_slug;

    if (isCreator) {
      let path = '/dashboard/community/post/';
      if (!item.post) {
        path += item.thread_deepness === 1 ? 'comment/' : 'comment/reply/';
      }
      return `${path}?slug=${slug}&main_post_ref=${mainPostRef}&scroll=scroll`;
    }

    // Non-creator
    if (item.post) {
      return `/creators/${item.creator_display_name}/communities/${
        item.conversation_id ?? item.id
      }/posts/${slug}`;
    }

    const base = item.thread_deepness === 1 ? 'comment' : 'comment/reply';
    return `/creator/community/post/${base}/?slug=${slug}&main_post_ref=${mainPostRef}&scroll=scroll`;
  },

  exclusive_content: (item: IExclusiveContent, isCreator) => {
    if (isCreator) {
      return `/dashboard/contents/editor/?id=${item.id}`;
    }
    return DynamicRouteBuilder.contentBySlug(item.creator_display_name, item.slug);
  },
};
